import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProductQualityDashboard } from '@apps/web/components/admin/product_quality/dashboard';

const qualityScoreboardSearchSchema = z.object({
    organizationId: z.string().optional(),
    // Saved links to retired views open the current issue dashboard.
    view: z.enum(['issues', 'runs', 'trends']).catch('issues'),
    trendDate: z.string().date().optional(),
    trendWindow: z.enum(['7', '30', '90']).optional(),
    churnWindow: z.enum(['30', '90', '180']).optional(),
    buyingWindow: z.enum(['current', '7', '30', '90']).optional(),
    trendAccount: z.string().optional(),
    trendSource: z.string().optional(),
    trendQuery: z.string().optional(),
    trendCategory: z.string().optional(),
    trendSeverity: z.enum(['high', 'medium', 'low']).optional(),
    trendKind: z.enum(['incident', 'pain', 'buying', 'churn']).optional(),
    trendOrder: z.enum(['newest', 'oldest', 'severity', 'title']).optional(),
    categoryOrder: z.enum(['count', 'name']).optional(),
    activeLinear: z.enum(['all', 'with', 'without']).optional(),
    issueId: z.string().uuid().optional(),
    status: z
        .enum([
            'active',
            'unaddressed',
            'untracked',
            'all',
            'open',
            'tracked',
            'ignored',
            'resolved',
            'merged',
            'ignored_with_new_reports',
        ])
        .optional(),
    painPoint: z.string().optional(),
    severity: z.enum(['critical', 'material', 'minor']).optional(),
    issueSeverity: z.enum(['red', 'yellow']).optional(),
});

export const Route = createFileRoute('/_app/admin/quality-scoreboard')({
    head: () => ({ meta: [{ title: 'Product Quality | Phoebe Admin' }] }),
    component: ProductQualityPage,
    validateSearch: qualityScoreboardSearchSchema,
});

function ProductQualityPage() {
    const filters = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <ProductQualityDashboard
            filters={filters}
            onChange={(patch) => {
                void navigate({
                    search: (current) => ({ ...current, ...patch }),
                });
            }}
        />
    );
}
